var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSystemFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0588 7.64706H0V5.88235H27.0588V7.64706Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24.1176H12.9412V22.3529H40V24.1176Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7647 10.8824C34.0388 10.8824 35.8823 9.03882 35.8823 6.76471C35.8823 4.49059 34.0388 2.64706 31.7647 2.64706C29.4906 2.64706 27.647 4.49059 27.647 6.76471C27.647 9.03882 29.4906 10.8824 31.7647 10.8824ZM31.7647 12.6471C35.0134 12.6471 37.647 10.0134 37.647 6.76471C37.647 3.51597 35.0134 0.882355 31.7647 0.882355C28.5159 0.882355 25.8823 3.51597 25.8823 6.76471C25.8823 10.0134 28.5159 12.6471 31.7647 12.6471Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23538 27.3529C10.5095 27.3529 12.353 25.5094 12.353 23.2353C12.353 20.9612 10.5095 19.1176 8.23538 19.1176C5.96127 19.1176 4.11773 20.9612 4.11773 23.2353C4.11773 25.5094 5.96127 27.3529 8.23538 27.3529ZM8.23538 29.1176C11.4841 29.1176 14.1177 26.484 14.1177 23.2353C14.1177 19.9866 11.4841 17.3529 8.23538 17.3529C4.98665 17.3529 2.35303 19.9866 2.35303 23.2353C2.35303 26.484 4.98665 29.1176 8.23538 29.1176Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemFilter);
export default __webpack_public_path__ + "static/media/SystemFilter.683c44723b75a17a4d295fe14ad71b81.svg";
export { ForwardRef as ReactComponent };